var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople2 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Calque_1",
    width: 20,
    height: 20,
    viewBox: "0 0 391.92 586.06",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198.43,
    cy: 126.1,
    r: 126.1,
    className: "cls-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.92 480.37c0-108.23-87.74-195.96-195.96-195.96S0 372.15 0 480.37v105.69h391.92z",
    className: "cls-1"
  })));
};
export { SvgPeople2 as ReactComponent };